
// Scope every lookup to the main product form so we never accidentally match
// cart-drawer elements (e.g. the shipping calculator's `.select__select`, which
// lives earlier in the DOM and would otherwise poison getPreorderSource()).
function getProductForm() {
  return document.querySelector('product-form.product-form');
}

// Per-variant stock data, computed server-side in Liquid (has access to the
// limited_preorder_stock metafield). Keyed by variant id.
let variantStockData = {};

function loadVariantStockData() {
  const form = getProductForm();
  const script = form ? form.querySelector('.preorder-variant-data') : null;
  if (!script) return;
  try {
    variantStockData = JSON.parse(script.textContent);
  } catch (e) {
    console.error(e);
  }
}

function getPreorderSource() {
  const form = getProductForm();
  if (!form) return null;

  // Prefer the per-variant data map keyed by the currently selected variant —
  // this stays accurate across variant changes for both dropdown and radio pickers.
  const variantId = getCurrentVariantId();
  if (variantId && variantStockData[variantId]) {
    const data = variantStockData[variantId];
    return {
      preorderqty: String(data.preorderQty),
      inventoryQty: String(data.inventoryQty),
      continueSelling: String(data.continueSelling)
    };
  }

  // Fallback: the selected option's / button's baked-in data attributes.
  const select = form.querySelector('.select__select');
  if (select) {
    return select.options[select.selectedIndex].dataset;
  }

  const button = form.querySelector('.product-form__submit');
  return button ? button.dataset : null;
}

function getRequestedQty() {
  const form = getProductForm();
  const quantityInput = form ? form.querySelector('.product-form__quantity input[id^="Quantity-"]') : null;
  const qty = quantityInput ? parseInt(quantityInput.value, 10) : 1;
  return isNaN(qty) || qty < 1 ? 1 : qty;
}

function getCurrentVariantId() {
  const form = getProductForm();
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  return idInput ? idInput.value : null;
}

// remaining_preorder_stock (data-preorderqty) already equals preorder_limit + inventory_qty,
// i.e. the whole sellable pool (in-stock + preorder). We deplete both numbers by however
// many units of this variant are already sitting in the cart.
let cartQtyByVariant = {};

function refreshCartQty() {
  return fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const quantities = {};
      cart.items.forEach((item) => {
        const key = String(item.variant_id);
        quantities[key] = (quantities[key] || 0) + item.quantity;
      });
      cartQtyByVariant = quantities;
    })
    .catch((e) => {
      console.error(e);
    });
}

function getStockState(source) {
  const variantId = getCurrentVariantId();
  const totalPool = parseInt(source.preorderqty, 10) || 0;
  const inCart = variantId ? (cartQtyByVariant[variantId] || 0) : 0;

  // How much is left after accounting for what's already in the cart.
  const inventoryQty = Math.max((parseInt(source.inventoryQty, 10) || 0) - inCart, 0);
  const preorderQty = Math.max(totalPool - inCart, 0);
  const continueSelling = source.continueSelling === "true";
  const qty = getRequestedQty();

  // Enough physical stock left for this request → plain Add to Cart.
  if (inventoryQty > 0 && qty <= inventoryQty) {
    return { state: "available", remaining: preorderQty };
  }

  // Physical stock exhausted but preorder pool still covers the request → Pre-order.
  if (continueSelling && preorderQty > 0 && qty <= preorderQty) {
    return { state: "preorder", remaining: preorderQty - inventoryQty };
  }

  // Unlimited-preorder variant (continue selling, no limit set).
  if (continueSelling && totalPool === 0) {
    return { state: "preorder", remaining: 0 };
  }

  return { state: "soldout", remaining: 0 };
}

function showinfo() {
  const preorder_info = document.querySelector('.preorder-availability-info');
  const preorder_qty_span = document.querySelector('.preorder-qty-text');
  const source = getPreorderSource();
  if (!source) return;

  const { state, remaining } = getStockState(source);
  const showinfo = state === "preorder";
  // =====================
  // SHOW / HIDE INFO
  // =====================
  if (preorder_info) {

    if (showinfo) {
      preorder_info.classList.add('show');
      if (preorder_qty_span) {
        preorder_qty_span.innerText = remaining;
      }
    } else {
      preorder_info.classList.remove('show');
    }

  }
}
// Enable/disable the hidden `properties[_Pre-order]` line item property so it is
// only submitted when the current variant is actually being pre-ordered. A
// disabled input is not serialized with the form, so the property is absent on
// plain add-to-cart purchases.
function setPreorderProperty(isPreorder) {
  const form = getProductForm();
  const input = form ? form.querySelector('.preorder-line-item-property') : null;
  if (!input) return;
  input.disabled = !isPreorder;
}

function updatePreordertext() {
  const form = getProductForm();
  const button = form ? form.querySelector('.product-form__submit') : null;

  if (!button) return;

  const source = getPreorderSource();
  if (!source) return;

  const { state } = getStockState(source);

  const isPreorder = state === "preorder";
  const isSoldOut = state === "soldout";

  // =====================
  // PREORDER
  // =====================
  if (isPreorder) {
    button.textContent = window.variantStrings.preOrder
    button.disabled = false;
    button.setAttribute("data-pre-order", "true");
    button.classList.add("preorder-btn");
    setPreorderProperty(true);
    return;
  }

  // =====================
  // SOLD OUT
  // =====================
  if (isSoldOut) {
    button.textContent = window.variantStrings.soldOut
    button.disabled = true;
    button.removeAttribute("data-pre-order");
    button.classList.remove("preorder-btn");
    setPreorderProperty(false);
    return;
  }

  // =====================
  // ADD TO CART
  // =====================
  button.textContent = window.variantStrings.addToCart
  button.disabled = false;
  button.removeAttribute("data-pre-order");
  button.classList.remove("preorder-btn");
  setPreorderProperty(false);
}

function refreshButtonState() {
  updatePreordertext();
  showinfo();
}

loadVariantStockData();

const form = getProductForm();
const quantityInput = form ? form.querySelector('.product-form__quantity input[id^="Quantity-"]') : null;

if (quantityInput) {
  quantityInput.addEventListener('change', refreshButtonState);
}

// Re-evaluate whenever the cart changes (add to cart, quantity change, remove).
refreshCartQty().then(refreshButtonState);
document.addEventListener('cart:updated', () => {
  refreshCartQty().then(refreshButtonState);
});

// Re-evaluate when the customer switches variants. The theme fires
// `productInfo:loaded` after it finishes re-rendering the variant (updating the
// hidden variant id input and toggling the button), so running here means our
// state has the last word instead of being clobbered by the theme's own toggle.
document.addEventListener('variant:change', refreshButtonState);
document.addEventListener('productInfo:loaded', refreshButtonState);

const button = form ? form.querySelector('.product-form__submit') : null;

if (button) {

  let lastDisabledState = button.disabled;

  const observer = new MutationObserver(() => {

    const isDisabled = button.disabled;

    // ONLY trigger when disabled → enabled
    if (lastDisabledState === true && isDisabled === false) {
      updatePreordertext();
    } else {
      setTimeout(() => {
        showinfo();
      }, 50);
    }

    lastDisabledState = isDisabled;

  });

  observer.observe(button, {
    attributes: true,
    attributeFilter: ['disabled']
  });
}
